export const HEADER_HEIGHT = 56;
export const COMPANY_CONTAINER = 936;
